import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  ROUTE_DEF_HOME,
  ROUTE_DEF_PLANS,
  ROUTE_DEF_SUBSCRIPTIONS,
  ROUTE_DEF_PAYMENTS,
  ROUTE_DEF_ORDER_SUMMARY,
  ROUTE_DEF_CHECKOUT,
  ROUTE_DEF_SUCCESS,
  ROUTE_DEF_PARTIAL_SUCCESS
} from "../constants/routes";
import MembershipHome from "./Membership/MembershipHome";
import PlanListView from "./Plans/PlanListView";
import SubscriptionView from "./Subscriptions/SubscriptionView";
import PaymentList from "./Payments/PaymentList";
import OrderSummary from "./Checkout/OrderSummary";
import CheckoutOrchestrator from "./Checkout/CheckoutOrchestrator";
import SubscriptionSuccess from "./Checkout/SubscriptionSuccess";
import SubscriptionPartialSuccess from "./Checkout/SubscriptionPartialSuccess";
import MembershipRoleGate from "./Membership/MembershipRoleGate";

/**
 * Nested routes for the Membership module (merged from MembershipMFE).
 *
 * Mounted at `/membership/*` (under `/:lang?`), so paths here are relative
 * to that mount point.
 */
const MembershipRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={ROUTE_DEF_HOME} element={<MembershipHome />} />
      <Route
        path={ROUTE_DEF_PLANS}
        element={
          <MembershipRoleGate>
            <PlanListView />
          </MembershipRoleGate>
        }
      />
      <Route
        path={ROUTE_DEF_SUBSCRIPTIONS}
        element={
          <MembershipRoleGate>
            <SubscriptionView />
          </MembershipRoleGate>
        }
      />
      <Route
        path={ROUTE_DEF_PAYMENTS}
        element={
          <MembershipRoleGate>
            <PaymentList />
          </MembershipRoleGate>
        }
      />
      <Route
        path={ROUTE_DEF_ORDER_SUMMARY}
        element={
          <MembershipRoleGate>
            <OrderSummary />
          </MembershipRoleGate>
        }
      />
      <Route
        path={ROUTE_DEF_CHECKOUT}
        element={
          <MembershipRoleGate>
            <CheckoutOrchestrator />
          </MembershipRoleGate>
        }
      />
      <Route
        path={ROUTE_DEF_SUCCESS}
        element={
          <MembershipRoleGate>
            <SubscriptionSuccess />
          </MembershipRoleGate>
        }
      />
      <Route
        path={ROUTE_DEF_PARTIAL_SUCCESS}
        element={
          <MembershipRoleGate>
            <SubscriptionPartialSuccess />
          </MembershipRoleGate>
        }
      />
    </Routes>
  );
};

export default MembershipRoutes;
